<template>
    <div class="Aviso">
        <div class="libe_home_nav" v-if="scroll >= 88">
            <headNav :activeNav="'loan'"></headNav>
        </div>
        <div class="libe_home_wrap">
            <div class="libe_homenav" v-if="scroll < 88 ">
                <headNav :activeNav="'loan'"></headNav>
            </div>

            <div class="arrecredi_home_banner" style="height: 270px;">

            </div>

            <div class="bigContent">
                <div class="content">
                    <div style="width: 100%; height: 60px; font-size: 32px; font-weight: bold; color: #333333;">AVISO DE PRIVACIDAD</div>
                    <p>
                        De conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (en adelante la "Ley"), su Reglamento y los Lineamientos del Aviso de Privacidad publicados en el Diario Oficial de la Federación el 17 de enero de 2013, Productos y servicios tepoztli, S.A. DE C.V. y su aplicación Amigocredi ponen a su disposición el presente Aviso de Privacidad bajo los siguientes términos:
                    </p>
                    <p style="font-weight: bold;">I. RESPONSABLE DEL TRATAMIENTO</p>
                    <p>
                        Productos y servicios tepoztli, S.A. DE C.V. (en adelante "Productos") con domicilio en Calle Roberto Gayol 1260， BenitoJuarez, Ciudad de Mexico, C.P. 03100, es responsable del tratamiento de sus datos personales, incluyendo obtención, uso, almacenamiento, transferencia y disposición.
                    </p>
                    <p style="font-weight: bold;">II. DATOS RECABADOS </p>
                    <p>
                        Recabamos datos necesarios para cumplir con nuestro objeto social y políticas corporativas, mediante:
                    </p>
                    <ul>
                        <li>
                            Datos de identificación: Nombre completo, dirección, teléfonos, RFC, CURP, FIEL, datos biométricos, geolocalización.
                        </li>
                        <li>
                            Datos personales: Información laboral, ingresos, nivel educativo.
                        </li>
                        <li>
                            Datos bancarios: Institución bancaria, CLABE, número de cuenta/tarjeta.
                        </li>
                        <li>
                            Datos de SMS: AmigoCredi solo accede a los mensajes de texto financieros almacenados en su dispositivo (obteniendo los campos: fecha, número de teléfono y contenido del mensaje). No recopilamos información no financiera ni compartimos el contenido de sus mensajes con terceros. Esta información se utiliza únicamente para el análisis de datos en modelos de gestión de riesgos, evaluar su elegibilidad para solicitar un préstamo y determinar si cumple con los requisitos para acceder a nuestros servicios. Los datos se cifran y se suben a nuestro servidor: https://api.amigocredi.mx. Nunca compartiremos su información sin su consentimiento. Solo accederemos a sus mensajes de texto después de obtener su autorización. Si desea eliminar sus datos, envíe un correo electrónico a amigocredi.contacto@gmail.com y los eliminaremos en un plazo de 3 a 5 días hábiles.  Sobre las reglas del filtrado de  mensajes: solo filtramos  los mensajes del usuario según palabras clave y solo capturamos aquellos que coincidan con las reglas establecidas. Las palabras clave incluyen, entre otras:  "presta", "cred", "liquida", "banco", "adeudo". Solo recopilamos mensajes de los últimos 6 meses.
                        </li>
                        <li>
                            Datos de dispositivo: Modelo, RAM, identificadores únicos (AAID, número de serie).
                        </li>
                        <li>
                            Ubicación: Para evaluación de riesgos en solicitudes de préstamo.
                        </li>
                        <li>
                            Cámara y almacenamiento: Solo para imágenes relacionadas con préstamos e identificaciones. Las fotos seleccionadas manualmente se guardan cifradas por 1 año.
                        </li>
                        <li>
                            Datos de Actividad en Apps: la actividad en app incluye nombre del paquete y la aplicación, el tiempo de la primera instalación y actualización.
                        </li>
                        <li>
                            Contactos de emergencia: Únicamente los seleccionados manualmente, almacenados cifrados por 1 año.
                        </li>
                        <li>
                            Permisos del dispositivo: Ubicación, cámara y datos de usuario.
                        </li>
                    </ul>
                    <p>
                        No recabamos datos sensibles (origen étnico, salud, creencias religiosas, preferencia sexual). Todos los datos se protegen con medidas de seguridad estrictas.
                    </p>
                    <p style="font-weight: bold;">III. Finalidades del Tratamiento</p>
                    <p>
                        Los datos se utilizarán para:
                    </p>
                    <ul>
                        <li>
                            Verificación de identidad y análisis de riesgo.
                        </li>
                        <li>
                            Cumplimiento de obligaciones legales y regulatorias.
                        </li>
                        <li>
                            Mantenimiento de información actualizada.
                        </li>
                        <li>
                            Formalización de contratos y relaciones comerciales.
                        </li>
                        <li>
                            Validación biométrica y biográfica.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">IV. Mecanismos para Manifestar Negativa al Tratamiento</p>
                    <p>
                        Si no está de acuerdo con este aviso, dispone de 5 días hábiles para manifestar su negativa al correo amigocredi.contacto@gmail.com (asunto: “Negativa para el Tratamiento de Datos Personales”). Nota: La negativa impedirá establecer una relación jurídica con Productos.
                    </p>

                    <p style="font-weight: bold;">V. Transferencia de Datos</p>
                    <p>
                        Sus datos podrán ser transferidos a:
                    </p>
                    <ul>
                        <li>
                            Burós de crédito (TransUnion, Círculo de Crédito).
                        </li>
                        <li>
                            Autoridades financieras y judiciales (cumplimiento legal).
                        </li>
                        <li>
                            Empresas subsidiarias o filiales.
                        </li>
                    </ul>
                    <p>
                        Todos los terceros garantizan la confidencialidad bajo este aviso.
                    </p>

                    <p style="font-weight: bold;">VI. Derechos ARCO (Acceso, Rectificación, Cancelación, Oposición)</p>
                    <p>Usted puede ejercer estos derechos mediante:</p>
                    <ul>
                        <li>
                            Solicitud escrita en RIO SAN JOAQUIN 463, CDMX (horario: 9:00-15:00 hrs).
                        </li>
                        <li>
                            Teléfono: (55) 8526-6878.
                        </li>
                        <li>
                            Plazo de respuesta: 20 días hábiles (ampliables a 40 en casos justificados).
                        </li>
                    </ul>
                    <p>Requisitos para la solicitud:</p>
                    <p>1. Nombre completo, domicilio y correo electrónico.</p>
                    <p>2. Documentos de identificación.</p>
                    <p>3. Descripción clara de los datos a modificar.</p>
                    <p>Excepciones: Productos podrá negar la cancelación si los datos son necesarios para cumplir con un contrato o una obligación legal. </p>

                    <p style="font-weight: bold;">VII. MODIFICACIONES</p>
                    <p>
                        Cualquier cambio se notificará mediante:
                    </p>
                    <ul>
                        <li>- Anuncios en oficinas</li>
                        <li>- Portal web de Productos  </li>
                        <li>- Email al último correo registrado </li>
                    </ul>
                    <p style="font-weight: bold;"> VIII. REVOCACIÓN DE CONSENTIMIENTO  </p>
                    <p>
                        Siga el procedimiento indicado en la sección VI. *Para atención en nuestra Unidad Especializada (UNE), agende cita al (55) 8526-6878*.
                    </p>
                    <p style="font-weight: bold;">IX. QUEJAS Y DENUNCIAS</p>
                    <p>
                        Si considera vulnerados sus derechos, acuda al INAI:  Insurgentes Sur 3211, Col. Insurgentes Cuicuilco, CDMX.  Tel. (55) 5004-2400 | https://home.inai.org.mx
                    </p>
                    <p style="font-weight: bold;">X. CONTACTO </p>
                    <p>¿Dudas sobre este aviso? Contáctenos: </p>
                    <ul>
                        <li><span style="font-weight: bold;">Atención al cliente:</span>+525585265083</li>
                        <li><span style="font-weight: bold;">Email:</span> amigocredi.contacto@gmail.com (respuesta en 2-3 días hábiles)  </li>
                        <li><span style="font-weight: bold;">WhatsApp:</span>+525659896766</li>
                        <li><span style="font-weight: bold;">Horario:</span>Lunes a Viernes de 08:00 a 17:00 y Sábado de 08:00 a 16:00</li>
                    </ul>
                </div>
            </div>
            <div class="bigContent">
                <div class="content">
                    <div style="width: 100%; height: 27px; padding: 0 0 10px 0; border-top: 1px solid #333333;"></div>
                    <div style="width: 100%; height: 60px; font-size: 32px; font-weight: bold; color: #333333;">PRIVACY NOTICE</div>
                    <p>
                        In compliance with the Federal Law on Protection of Personal Data Held by Private Parties (hereinafter the "Law"), its Regulations, and the Privacy Notice Guidelines published in the Official Gazette of the Federation on January 17, 2013, Productos y Servicios Tepoztli, S.A. de C.V. and its application AmigoCredi make this Privacy Notice available to you under the following terms:
                    </p>
                    <p style="font-weight: bold;">I. DATA CONTROLLER</p>
                    <p>
                        Productos y Servicios Tepoztli, S.A. de C.V. (hereinafter "Productos"), with its registered office at Calle Roberto Gayol 1260, Benito Juárez, Mexico City, C.P. 03100, is responsible for the processing of your personal data, including collection, use, storage, transfer, and disposal.
                    </p>
                    <p style="font-weight: bold;">II. DATA COLLECTED </p>
                    <p>
                        We collect necessary data to fulfill our corporate purpose and policies through:
                    </p>
                    <ul>
                        <li>
                            Identification data: Full name, address, phone numbers, RFC (Tax ID), CURP (Unique Population Registry Code), FIEL (e-signature), biometric data, geolocation.
                        </li>
                        <li>
                            Personal data: Employment information, income, education level.
                        </li>
                        <li>
                            Banking data: Financial institution, CLABE (bank account number), card/account number.
                        </li>
                        <li>
                            <p>SMS data:</p>
                            <p>
                                <span style="font-weight: bold;">Information Access and Collection Scope:</span> AmigoCredi only accesses financial - related SMS messages stored on your device, with the involved fields including date, phone number, and SMS content. Non-financial information is not within the scope of collection.
                                In terms of the collection scope of SMS messages, only those from the past six months are included.
                            </p>
                            <p>
                                <span style="font-weight: bold;">SMS Filtering Principles:</span> SMS messages are obtained through keyword filtering rules, and the keywords include but are not limited to "presta", "cred", "liqudia", "banco", "adeudo", etc.
                            </p>
                            <p>
                                <span style="font-weight: bold;">Information Usage:</span> The obtained information is solely used for data analysis of the risk control model and evaluating the user's loan application qualifications to determine whether the user meets the service access conditions.
                            </p>
                            <p>
                                <span style="font-weight: bold;">Information Transmission and Storage:</span> After being encrypted, the data will be uploaded to a dedicated server (https://api.amigocredi.mx).
                            </p>
                            <p>
                                <span style="font-weight: bold;">Information Confidentiality:</span> Without the user's explicit permission, the content of SMS messages and related data will never be shared with any third parties. SMS access will only be conducted after obtaining the user's authorization.
                            </p>
                            <p>
                                <span style="font-weight: bold;">Information Deletion Mechanism:</span> If a user needs to delete personal information, they can send an application email to amigocredi.contacto@gmail.com, and the relevant information will be deleted within 3 to 5 working days.
                            </p>
                        </li>
                        <li>
                            Device data: Model, RAM, unique identifiers (AAID, serial number).
                        </li>
                        <li>
                            Location: For risk assessment in loan applications.
                        </li>
                        <li>
                            Camera and storage: Only for loan-related images and identification documents. Manually selected photos are stored encrypted for 1 year.
                        </li>
                        <li>
                            App Activity Data: Package name, application name, time of first installation, and time of update.
                        </li>
                        <li>
                            Emergency contacts: Only manually selected contacts, stored encrypted for 1 year.
                        </li>
                        <li>
                            Device permissions: Location, camera, and user data.
                        </li>
                    </ul>
                    <p>
                        We do not collect sensitive data (ethnic origin, health, religious beliefs, sexual orientation). All data is protected with strict security measures.
                    </p>
                    <p style="font-weight: bold;">III. PURPOSES OF PROCESSING</p>
                    <p>
                        Data will be used for:
                    </p>
                    <ul>
                        <li>
                            Identity verification and risk analysis.
                        </li>
                        <li>
                            Compliance with legal and regulatory obligations.
                        </li>
                        <li>
                            Keeping records updated.
                        </li>
                        <li>
                            Formalizing contracts and business relationships.
                        </li>
                        <li>
                            Biometric and biographical validation.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">IV. OPT-OUT MECHANISMS</p>
                    <p>
                        If you disagree with this notice, you have 5 business days to express your refusal by emailing amigocredi.contacto@gmail.com (subject: "Refusal for Processing of Personal Data"). Note: Refusal will prevent establishing a legal relationship with Productos.
                    </p>

                    <p style="font-weight: bold;">V. DATA TRANSFERS</p>
                    <p>
                        Your data may be shared with:
                    </p>
                    <ul>
                        <li>
                            Credit bureaus (TransUnion, Círculo de Crédito).
                        </li>
                        <li>
                            Financial and judicial authorities (legal compliance).
                        </li>
                        <li>
                            Subsidiaries or affiliates.
                        </li>
                    </ul>
                    <p>
                        All third parties guarantee confidentiality under this notice.
                    </p>

                    <p style="font-weight: bold;">VI. ARCO RIGHTS (Access, Rectification, Cancellation, Opposition)</p>
                    <p>You may exercise these rights by:</p>
                    <ul>
                        <li>
                            Written request at RIO SAN JOAQUIN 463, Mexico City (hours: 9:00–15:00).
                        </li>
                        <li>
                            Phone: (55) 8526-6878.
                        </li>
                        <li>
                            Response time: 20 business days (extendable to 40 in justified cases).
                        </li>
                    </ul>
                    <p>Request requirements:</p>
                    <p>1. Full name, address, and email.</p>
                    <p>2. Identification documents.</p>
                    <p>3. Clear description of data to modify.</p>
                    <p>Exceptions: Productos may deny cancellation if data is required for contractual or legal obligations.</p>

                    <p style="font-weight: bold;">VII. MODIFICATIONS</p>
                    <p>
                        Any changes will be notified via:
                    </p>
                    <ul>
                        <li>Office notices.</li>
                        <li>Productos’ website.</li>
                        <li>Email to the last registered address.</li>
                    </ul>
                    <p style="font-weight: bold;"> VIII. WITHDRAWAL OF CONSENT</p>
                    <p>
                        Follow the procedure in Section VI. *For assistance at our Specialized Unit (UNE), schedule an appointment at (55) 8526-6878*.
                    </p>
                    <p style="font-weight: bold;">IX. COMPLAINTS</p>
                    <p>
                        If you believe your rights have been violated, contact INAI:
                        Insurgentes Sur 3211, Col. Insurgentes Cuicuilco, Mexico City
                        Tel. (55) 5004-2400 | https://home.inai.org.mx
                    </p>
                    <p style="font-weight: bold;">X. CONTACT </p>
                    <p>Questions about this notice? Contact us:</p>
                    <ul>
                        <li><span style="font-weight: bold;">Customer service:</span>+ 52 55 8526 5083</li>
                        <li><span style="font-weight: bold;">Email:</span> amigocredi.contacto@gmail.com (response in 2–3 business days) </li>
                        <li><span style="font-weight: bold;">WhatsApp:</span> +52 56 5989 6766</li>
                        <li><span style="font-weight: bold;">Hours:</span> Mon–Fri 8:00–17:00, Sat 8:00–16:00 </li>
                    </ul>
                </div>
            </div>
        </div>
        <footPage></footPage>
    </div>
</template>

<script>

    import $ from 'jquery';
    import headNav from "@/components/headNav.vue";
    import footPage from "@/components/foot.vue";
    import "../components/scss/Aviso.scss";

    export default {
        name: "loan",
        components: { headNav, footPage },
        data() {
            return {
                scroll: 0,
                activeName: 'first',
            }
        },
        mounted(){
            document.documentElement.scrollTop = 0;
            window.addEventListener('scroll',this.handleScroll);
            if(this.$route.query.activeName){
                this.activeName = this.$route.query.activeName;
            }
            this.$nextTick(() => {
                $('.el-tabs__active-bar').css({
                    width: '150px'
                })
            });


        },
        methods: {
            handleClick(tab, event){
                console.log(tab)
                console.log(event)
                this.$nextTick(() => {
                    setTimeout(() => {
                        $('.el-tabs__active-bar').css({
                            width: '150px'
                        })
                    }, 100)
                });
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop||document.body.scrollTop
            },
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }
</script>

<style>
    .title p span {
        border-bottom: 3px solid #4e67f1;
    }
    .arrecredi_home_banner{
        width: 100%;
        height: 402px;
        position: relative;
        overflow: hidden;
        z-index: 2;
    }
    .bigContent .el-tabs__item{
        height: 58px;
        font-weight: bold;
        font-size: 32px;
        color: #262A48;
    }
    .bigContent .el-tabs__item:hover{
        color: #262A48;
    }
    .bigContent .el-tabs__active-bar{
        height: 3px;
        background: #262A48;
    }
    .bigContent .el-tabs__item.is-active{
        color: #262A48;
    }
    .bigContent .el-tabs__nav-wrap::after{
        height: 0;
    }
    #tab-first{
        width: 495px;
    }
    .arrecrediprivacidad_view{
        width: 100%;
        padding: 50px 0 0 0;
    }
</style>

